/** ArticleFooter (G2, D9): brand · links · copyright; one row on desktop, stacked 44px rows on phones. */
import React, { memo } from 'react';
import type { ArticleBlockProps } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/types';
import { articleLinkTargetProps, resolveArticleHref } from '@modules/screen-view-v2/utils/articleLinks';
import { resolveLocaleText } from '@modules/screen-view-v2/utils/articleText';

export const ArticleFooter = memo(function ArticleFooter({ section, locale, article }: ArticleBlockProps): React.ReactElement | null {
  const content = section.articleFooterContent;
  if (!content) return null;
  const brand = resolveLocaleText(content.brand, locale);
  const copyright = resolveLocaleText(content.copyright, locale);
  const siteOrigin = article.runtime?.siteOrigin;
  return (
    <footer className="ap-block ap-footer">
      <div className="ap-footer-row">
        {brand ? <span className="ap-footer-brand">{brand}</span> : null}
        {(content.links ?? []).map((link, index) => {
          const href = resolveArticleHref(link.href);
          const text = resolveLocaleText(link.label, locale);
          if (!href || !text) return null;
          return (
            <a key={`${index}:${link.href}`} className="ap-footer-link" href={href} {...articleLinkTargetProps(href, link.target, siteOrigin)}>{text}</a>
          );
        })}
        {copyright ? <span className="ap-footer-copy">{copyright}</span> : null}
      </div>
    </footer>
  );
});

ArticleFooter.displayName = 'ArticleFooter';
